import React from "react";
import PropTypes from "prop-types";
// import moment from "moment";
import {
  advancedFilterWorker,
  // renderDate,
  sortDateAscendingOrder,
  tableSkeleton
} from "../../../constant/helper/helper";
import ShowDateList from "./ShowDateList";
import { Link } from "react-router-dom";
import useSortableData from "../../../customHooks/sortingHooks";
// import Span from "../../../component/smallComponents/Span";
import { tableHeaderData } from "./sheetStaticData";
import TableHeader from "../../../component/tableHeader/TableHeader";

const AttendanceUserList = ({
  values,
  loading,
  loginType,
  dateArrayState,
  loginTypeConstant,
  attendanceSheetData,
  excelRef,
  dateDifference
}) => {
  const onHeaderChange = (valueObject) => {
    return dateArrayState.map((dateRange, dateRangeIndex) => (
      <th key={dateRangeIndex} className="text-center">
        {dateRange}
      </th>
    ));
  };
  const showUserList = (sheetData) => {
    if (loading) {
      return <tr>{tableSkeleton(10 + Number(dateDifference))}</tr>;
    } else if (
      typeof sheetData !== "undefined" &&
      sheetData !== null &&
      sheetData.length > 0
    ) {
      const filterEmployees = advancedFilterWorker(
        sheetData,
        values.Filter,
        "fullNameAndId"
      );
      // console.log(filterEmployees);
      return filterEmployees.map((mapData, parentIndex) => {
        const sortedDateList = sortDateAscendingOrder(mapData);
        return (
          <tr key={parentIndex} style={{ fontSize: 12 }}>
            <td>{parentIndex + 1}</td>
            <td style={{ fontSize: 12 }}>{mapData.workerId}</td>
            <td className="table-user">
              <span className="text-body font-weight-semibold">
                <Link to={`/hr/user/all-users/${mapData.employeeId}`}>
                  {mapData.workerFullName}
                </Link>
              </span>
            </td>
            <td style={{ fontSize: 12 }}>
              {mapData.workerDepartment}
            </td>
            <td style={{ fontSize: 12 }}>
              {mapData.workerDesignation}
            </td>
            <td className="text-center" style={{ fontSize: 12 }}>
              {mapData.Location}
            </td>
            <td className="text-center" style={{ fontSize: 12 }}>
              {loginType}
            </td>
            <ShowDateList dayList={sortedDateList} values={values} />

            <td className="table-action text-center">
              <span className="text-dark">
                {Math.round(mapData.totalDays)}
              </span>
            </td>
            <td className="table-action text-center">
              <span className="text-dark">
                {Math.round(mapData.totalValue)}
              </span>
            </td>
          </tr>
        );
      });
    } else if (sheetData === null) {
      return (
        <tr style={{ top: "50%", left: "50%", position: "fixed" }}>
          <td>
            <span className="">
              Please Select From Date, To Date and Location
            </span>
          </td>
        </tr>
      );
    } else if (sheetData.length === 0) {
      return (
        <tr style={{ top: "50%", left: "50%", position: "fixed" }}>
          <td>
            <span className=""> No Record Found</span>
          </td>
        </tr>
      );
    }
  };

  const { items, requestSort, sortConfig } = useSortableData(
    attendanceSheetData
  );

  return (
    <div
      className="table-responsive"
      style={{ height: "700px", overflow: "auto" }}
    >
      <table
        className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
        id="products-datatable"
      >
        <thead className="thead-light">
          <tr>
            <th style={{ width: "20px" }}>#</th>
            <TableHeader
              tableHeaderData={tableHeaderData}
              requestSort={requestSort}
              sortConfig={sortConfig}
            />

            <th className="text-center">Type</th>
            {onHeaderChange(values)}
            <th className="text-center">Total Days</th>
            <th className="text-center">{values.dataType}</th>
          </tr>
        </thead>
        <tbody>{showUserList(items)}</tbody>
      </table>
    </div>
  );
};

AttendanceUserList.propTypes = {
  excelRef: PropTypes.any,
  loading: PropTypes.bool,
  values: PropTypes.object.isRequired,
  attendanceSheetData: PropTypes.array,
  loginType: PropTypes.string.isRequired,
  dateArrayState: PropTypes.array.isRequired,
  loginTypeConstant: PropTypes.object.isRequired,
  dateDifference: PropTypes.number.isRequired
};

export default AttendanceUserList;
